module.exports = __webpack_public_path__ + "img/secure-video.d2fbb57a.jpg";